import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;

const Loading = ({ loading = false, children }) => {
    return (
        <LoadingOverlay
            active={loading}
            spinner
            styles={{
                overlay: (base) => ({
                    ...base,
                    background: "rgba(255, 255, 255, 0.5)",
                }),
                spinner: (base) => ({
                    ...base,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    "& svg circle": {
                        stroke: "rgba(255, 0, 0, 0.5)",
                    },
                }),
            }}
        >
            {children}
        </LoadingOverlay>
    );
};

export default Loading;
